import { render, staticRenderFns } from "./PopUpMapNijmegen.vue?vue&type=template&id=9f32c460&"
import script from "./PopUpMapNijmegen.vue?vue&type=script&lang=js&"
export * from "./PopUpMapNijmegen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports